import React from 'react';
import { cn } from '@/lib/utils';
import starts from '@/imgs/starts.png';
interface SummaryProps {
  title?: string;
  icon?: string;
  iconAlt?: string;
  content?: string;
  suggestions?: string[];
  className?: string;
  isShowSuggestions?: boolean;
  children?: React.ReactNode;
}

const Summary: React.FC<SummaryProps> = ({
  title = 'AI智能诊断总结',
  icon = starts,
  iconAlt = 'AI诊断',
  content = '您的持仓结构相对均衡，现金管理占比35%提供流动性保障，稳健收益40%确保稳定回报，进取收益25%追求超额收益。行业分布方面，科技25%、金融22%的配置体现了成长与稳健的平衡。持仓基金数18只较为分散，有助于降低单一基金风险。持仓集中度适中，风格偏向成长型投资。',
  suggestions = [
    '最大行业比例25%控制良好，避免过度集中；',
    '可考虑适当增加债券型基金配置以进一步平衡风险；',
    '定期评估持仓风格分布，保持价值与成长的均衡配置；',
    '适当增加价值型基金以平衡风险。'
  ],
  isShowSuggestions = true,
  className = '',
  children
}) => {
  return (
    // <div className={className}>
    <div
      className={cn('rounded-lg p-[2px]', className)}
      style={{
        background: 'linear-gradient(267deg, #3215F3 4.19%, #ECB1FF 86.14%)'
      }}
    >
      {/* AI智能诊断总结卡片 */}
      <div
        className="rounded-lg p-3"
        style={{ background: 'linear-gradient(267deg, #EEEDFF 4.19%, #F6F7FF 86.14%)' }}
      >
        {title && (
          <div className="mb-2 flex items-center gap-1">
            <div className="h-6 w-6">
              <img src={icon} className="h-full w-full object-cover" alt={iconAlt} />
            </div>
            <span className="text-base font-semibold text-[#1F1F1F]">{title}</span>
          </div>
        )}
        {children ? (
          children
        ) : (
          <>
            {content && (
              <p className="mb-3 text-left text-xs leading-[20px] text-[#1F1F1F]">{content}</p>
            )}

            {/* 建议标题 */}
            {isShowSuggestions && (
              <div className="mb-2 flex items-center gap-1">
                <span className="text-sm font-semibold text-[#1F1F1F]">建议</span>
              </div>
            )}

            {/* 建议内容 */}
            {isShowSuggestions && (
              <div className="rounded-md p-2">
                <p className="text-left text-xs leading-relaxed text-[#1F1F1F]">
                  {suggestions.map((suggestion, index) => (
                    <React.Fragment key={index}>
                      <span className="mr-1 text-xs text-[#1F1F1F]">•</span> {suggestion}
                      {index < suggestions.length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </p>
              </div>
            )}
          </>
        )}
      </div>
    </div>
    // </div>
  );
};

export default Summary;
